export default __webpack_public_path__ + "static/media/mn_tea_sub_4.d025fcfa.png";